import { DvGridComponent } from '@devinco/ui/grid';
import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { GridOptionsService } from '@features/vt-grid/grid-options/grid-options.service';
import { GridOptions } from '@features/vt-grid/interfaces/grid-options';
import { Entity } from '@shared/constants/entity';
import {
  IRowNode,
  IsRowSelectable,
  SelectionChangedEvent,
} from 'ag-grid-community';
import { AddUserRoleService } from './add-user-role.service';
import { AgGridModule } from 'ag-grid-angular';
import { TranslateModule } from '@ngx-translate/core';
import {
  DvButtonComponent,
  DvDialogContent,
  DvDialogContentComponent,
} from '@devinco/ui/dds';
import { DirectivesModule } from '@shared/directives/directives.module';
import { RoleDto } from '@pages/settings-page/access-control-settings/roles/grid/interfaces';
import { UserRoleDto } from '@pages/users-page/components/user-access-control-tab/interfaces';

@Component({
  imports: [
    DvGridComponent,
    AgGridModule,
    DvButtonComponent,
    DvDialogContentComponent,
    TranslateModule,
    DirectivesModule,
  ],
  selector: 'app-add-user-role-dialog',
  templateUrl: './add-user-role-dialog.component.html',
  styleUrls: ['./add-user-role-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [AddUserRoleService, GridOptionsService],
})
export class AddUserRoleDialogComponent
  extends DvDialogContent<UserRoleDto[], AddUserRoleDialogComponent>
  implements OnInit
{
  readonly gridOptionService = inject(GridOptionsService);
  private readonly addUserRoleService = inject(AddUserRoleService);

  gridOptions: GridOptions<RoleDto>;
  selectedNodes: IRowNode<RoleDto>[] | undefined;
  private existingRoleIds: number[];

  ngOnInit(): void {
    this.existingRoleIds = this.data.map(role => role.RoleID);
    this.gridOptions = {
      ...this.gridOptionService.clientSide(
        this.addUserRoleService.colDefs,
        Entity.Role
      ),
      rowSelection: {
        mode: 'multiRow',
        enableClickSelection: true,
        enableSelectionWithoutKeys: true,
        isRowSelectable: this.isRowSelectable,
      },
      rowGroupPanelShow: 'never',
    };
  }

  onSelectionChanged({ api }: SelectionChangedEvent): void {
    this.selectedNodes = api.getSelectedNodes();
  }

  performSave(): void {
    const newlySelectedNodes = this.selectedNodes?.filter(node => {
      return !this.existingRoleIds.includes(node.data!.RoleID);
    });
    this.dialogRef.onConfirm(newlySelectedNodes);
  }

  cancel(): void {
    this.dialogRef.onCancel();
  }

  private isRowSelectable: IsRowSelectable = (node: IRowNode<RoleDto>) => {
    if (this.existingRoleIds.includes(node.data!.RoleID)) {
      node.setSelected(true);
      return false;
    } else if (!node.data!.Enabled) {
      return false;
    } else {
      return true;
    }
  };
}
